import GameActionsModal from './game-actions-modal';

export default GameActionsModal;
